import { toast } from 'react-toastify';
import React from 'react';
import PropTypes from 'prop-types';

const FileUpload = ({ onImport, component, id }) => {
    const handleOnChange = (e) => {
        const fileHandler = (file) => {
            const reader = new FileReader();
            return new Promise((resolve, reject) => {
                reader.onload = event => resolve(event.target.result);
                reader.onerror = error => reject(error);
                reader.readAsText(file);
            });
        };
        fileHandler(e.target.files[0]).then(content => {
            try {
                const data = JSON.parse(content);
                onImport && onImport(data);
            } catch (err) {
                toast.error(`handleOnChange Failed to import file: ${err && err.message}`);
                console.error('handleOnChange', err);
            }
        }).catch(err => {
            toast.error('handleOnChange Cannot import file');
            console.error('handleOnChange', err);
        });
    };

    return (
        <React.Fragment>
            <label htmlFor="file-upload">
                {React.cloneElement(component, { onClick: () => {} })}
            </label>
            <input
                id="file-upload"
                type="file"
                onClick={(e) => { e.target.value = null }}
                style={{ display: 'none' }}
                onChange={handleOnChange}/>
        </React.Fragment>
    );
};
FileUpload.propTypes = {
    component: PropTypes.node,
    onImport: PropTypes.func,
    id: PropTypes.string,
};

export default FileUpload;
